// extracted by mini-css-extract-plugin
export default {"headerFlex":"_Header_headerFlex__JFNtu","ham":"_Header_ham__OxLCi","headerspan":"_Header_headerspan__s-wcD","headerNav":"_Header_headerNav__c4qGp"};